/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'new-subbucket-folder',
  components: {},
  props: ['newSubBucketFolderID'],
  data () {
    return {
      submitted:false,
      name:''
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    getBucketListAgainMethod(){
      this.$store.dispatch('getBucketListOfAwerackFun').then((res)=>{
      }).catch((err) => {})
    },
    createNewSubBucketBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            name:this.name,
            parent:this.newSubBucketFolderID,
            is_folder:true
          }
          this.$store.dispatch('createBucketOfAwerackDetailsFun', data)
            .then((res) => {  
              this.$validator.reset()
              toast.success(res.data.msg);
              this.getBucketListAgainMethod()
              this.closeCreateNewSubBucketPopup()
              this.submitted =  false
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeCreateNewSubBucketPopup(){
      bus.$emit('newSubBucketFolderPopupStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    }
  }
}